<template>
    <div>
        <div class="card-body">
            <form>
                <div class="form-group">
                    <label for="">Server <span class="text-danger">*</span></label>
                    <input
                        type="text"
                        name=""
                        class="form-control"
                        id="imap_server"
                        v-model="imap_server"
                        :class="errors['imap_server'] ? 'border border-danger' : ''"
                    />
                    <span v-if="errors['imap_server']" class="text-danger">{{
                        errors["imap_server"][0]
                    }}</span>
                </div>

                <div class="form-group">
                    <label for="imap-username">Username <span class="text-danger">*</span></label>
                    <input
                        type="username"
                        name=""
                        class="form-control"
                        id="imap-username"
                        v-model="username"
                        :class="errors['username'] ? 'border border-danger' : ''"
                    />
                    <span v-if="errors['username']" class="text-danger">{{
                        errors["username"][0]
                    }}</span>
                </div>

                <div class="form-group mb-1">
                    <label for="imap-password">Password <span class="text-danger">*</span></label>
                    <div class="input-group">
                        <input
                        :type="password_type"
                        name=""
                        class="form-control"
                        id="imap-password"
                        v-model="password"
                        :class="errors['password'] ? 'border border-danger' : ''"
                        />
                        <div
                        class="input-group-append"
                        style="cursor: pointer"
                        @click="showPassword()"
                        >
                            <span class="input-group-text">
                                <!-- <i class="fa fa-eye"></i> -->
                                <i
                                :class="
                                    password_type == 'password'
                                    ? 'fa fa-eye'
                                    : 'fa fa-eye-slash'
                                "
                                ></i>
                            </span>
                        </div>
                    </div>

                    <span v-if="errors['password']" class="text-danger">{{
                        errors["password"][0]
                    }}</span>
                </div>

                <div class="form-group">
                    <label for="from_email">From Email Address <span class="text-danger">*</span></label>
                    <input
                        type="email"
                        name=""
                        class="form-control"
                        id="from_email"
                        v-model="from_email"
                        :class="errors['from_email'] ? 'border border-danger' : ''"
                    />
                    <span v-if="errors['from_email']" class="text-danger">{{
                        errors["from_email"][0]
                    }}</span>
                </div>

                <div class="form-group">
                    <label for="">Subject</label>
                    <input
                        type="email"
                        name=""
                        class="form-control"
                        id="subject"
                        v-model="subject"
                        :class="errors['subject'] ? 'border border-danger' : ''"
                    />
                    <span v-if="errors['subject']" class="text-danger">{{
                        errors["subject"][0]
                    }}</span>
                </div>
            </form>
        </div>
        <div class="card-footer">
          <button
                class="btn btn-warning"
                style="float: left"
                @click="testConnection()"
                ref="kt_test_connections"
            >
                <i class="fa fa-envelope"></i>Test IMAP Connection
            </button>
            <button
                class="btn btn-success"
                style="float: right"
                ref="kt_save_configure"
                @click="onSubmit()"
            >
                <i class="fa fa-check"></i>Save
            </button>
        </div>
    </div>
</template>

<script>
import {
  FETCH_IMAP_CONFIG,
  UPDATE_IMAP_CONFIG,
  TEST_IMAP_CONFIG
} from "@/core/services/store/actions.type";

export default {
  data() {
    return {
      errors: [],
      regEmail: /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,

      id: 0,
      imap_server: "",
      username: "",
      password: "",
      from_email: "",
      subject: "",
      password_type: "password"
    };
  },

  created() {
    this.$store.dispatch(FETCH_IMAP_CONFIG).then(data => {
      if (data.success == true) {
        this.id = data.data.id;
        this.imap_server = data.data.imap_server;
        this.username = data.data.username;
        this.password = data.data.password;
        this.from_email = data.data.from_email;
        this.subject = data.data.subject;
      }
    });
  },
  methods: {
    showPassword() {
      if (this.password_type === "password") {
        this.password_type = "text";
      } else {
        this.password_type = "password";
      }
    },

    testConnection() {
      this.errors = [];
      const testButton = this.$refs["kt_test_connections"];
      testButton.disabled = true;
      testButton.classList.add("spinner", "spinner-light", "spinner-right");
      this.$store
        .dispatch(TEST_IMAP_CONFIG, {
          imap_server: this.imap_server,
          username: this.username,
          password: this.password,
        })
        .then(data => {
          testButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
          testButton.disabled = false;
          this.$toastr.s(data.msg);
        })
        .catch(err => {
          testButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
          testButton.disabled = false;
          this.errors = err.error || "Error";
          this.$toastr.e("Error");
        });
    },

    onSubmit() {
      this.errors = [];
      const submitButton = this.$refs["kt_save_configure"];
      submitButton.disabled = true;
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");

      var data_ = {
        id_: this.id,
        imap_server: this.imap_server,
        username: this.username,
        password: this.password,
        from_email: this.from_email,
        subject: this.subject
      };
      // this.loadingButton(ref);
      this.$store
        .dispatch(UPDATE_IMAP_CONFIG, data_)
        .then(data => {
          submitButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
          submitButton.disabled = false;
          if (this.id == 0) {
            this.id = data.id;
          }
          this.$toastr.s(data.msg);
        })
        .catch(err => {
          submitButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
          submitButton.disabled = false;
          this.errors = err.error;
        });
    }
  }
};
</script>